"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signAndSendAllTransactionsInSequence = void 0;
//? Sequence means that transactions will be signed at once, but will be sent in a sequence by chunks.
//? F.e. txnsAndSigners: [[x, x, x], [y, y, y], [z, z, z]]. Sign all txns at once. But first send [x, x, x], wait for confirmation, send [y, y, y] wait for confirmation, send [z, z, z]
//? It needs when transactions from next chunk are related to transactions from previos chunk
const signAndSendAllTransactionsInSequence = ({ txnsAndSigners, connection, wallet, commitment = 'confirmed', onBeforeApprove, onAfterSend, onSuccess, onError, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        //? Filter empty arrays from two-dimensional array
        const txnsAndSignersFiltered = txnsAndSigners.filter((arr) => !!arr.length);
        onBeforeApprove === null || onBeforeApprove === void 0 ? void 0 : onBeforeApprove();
        const { blockhash, lastValidBlockHeight } = yield connection.getLatestBlockhash();
        const transactionsFlatArr = txnsAndSignersFiltered.flat().map(({ transaction, signers = [] }) => {
            transaction.recentBlockhash = blockhash;
            transaction.feePayer = wallet.publicKey;
            if (signers.length) {
                transaction.sign(...signers);
            }
            return transaction;
        });
        const signedTransactions = yield wallet.signAllTransactions(transactionsFlatArr);
        const allTxnSignatures = [];
        let currentTxIndex = 0;
        for (let i = 0; i < txnsAndSigners.length; i++) {
            for (let r = 0; r < txnsAndSigners[i].length; r++) {
                console.log('currentTxIndex: ', currentTxIndex);
                const txn = signedTransactions[currentTxIndex];
                yield connection.sendRawTransaction(txn.serialize(), {
                    skipPreflight: false,
                    preflightCommitment: 'processed',
                });
                currentTxIndex += 1;
            }
            if (txnsAndSigners[i].length > 0)
                yield new Promise((r) => setTimeout(r, 7000));
        }
        onAfterSend === null || onAfterSend === void 0 ? void 0 : onAfterSend();
        yield new Promise((r) => setTimeout(r, 7000));
        // const results = await Promise.allSettled(
        //   allTxnSignatures.map((signature) =>
        //     connection.confirmTransaction(
        //       {
        //         signature,
        //         blockhash,
        //         lastValidBlockHeight,
        //       },
        //       commitment,
        //     ),
        //   ),
        // );
        // //? Can't cover this shit with types properly
        // const resultsContainErr = results
        //   .map((res) => !!(res as any)?.value?.value?.err)
        //   .find(Boolean);
        // if (resultsContainErr) {
        //   throw new Error('Transaction contains error');
        // }
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        return true;
    }
    catch (error) {
        onError === null || onError === void 0 ? void 0 : onError(error);
        return false;
    }
});
exports.signAndSendAllTransactionsInSequence = signAndSendAllTransactionsInSequence;
